import { NgModule } from '@angular/core';
import { Component, OnInit, Inject, ElementRef, Renderer  } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';

export interface AlertaPremium {
    origem: string;
}

@Component({
    selector: 'alerta-premium',
    templateUrl: './alerta-premium.html',
    styleUrls: ['./alerta-premium.css']
  })
  export class AlertaPremiumDialog {
    
    //@ViewChild("fakeInput") inputEl: ElementRef;
    constructor(
      public dialogRef: MatDialogRef<AlertaPremiumDialog>,
      @Inject(MAT_DIALOG_DATA) public data: AlertaPremium, private elRef: ElementRef, private renderer: Renderer) {}
  
    ngOnInit(){
      console.log("sabot");
    //   setTimeout(() => {
    //     this.renderer.invokeElementMethod(
    //       this.elRef.nativeElement.ownerDocument.activeElement, 'focus');
    //   }, 500);
      
      }
    onNoClick(): void {
      this.dialogRef.close(0);
      //return false;
    }
    onSaibaMais() :void{
        this.dialogRef.close(1);
    }
    onConfirmClick() :void {
        this.dialogRef.close(2);
    //   setTimeout(() => {
    //     this.dialogRef.close(true);
    //      this.renderer.invokeElementMethod(
    //         this.elRef.nativeElement.ownerDocument.activeElement, 'blur');
    //   }, 0);

    }
  
}